import { dispatch } from "@rematch/core";
import { getPrimaryCategories, getSecondCategories } from "utils/interface";
import { CQ } from "utils/commonQuest";

export const orderSource = {
  state: {},
  effects: {
    // 获取一级类目数据
    async getPrimaryCategories(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getPrimaryCategories);
      const data = await CQ(getPrimaryCategories());
      dispatch["share"].updatePriarmyCategories(data);
    },
    // 获取二级类目数据
    async getSecondCategories(payload: any, rootState: any) {
      // 等待异步调用的结果
      //const data = await _GET(APIS.getSecondCategories);
      const data = await CQ(getSecondCategories());
      dispatch["share"].updateSecondCategories(data);
    }
  }
};
